import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestPostInterviewsClickedPayload {
  postingId: string;
  interviewCount: number;
}

/**
 * Fires when user clicks "Post Interviews" on the interview request page
 * Event: dental_portal:interview_request:post_interviews_clicked
 */
export function fireInterviewRequestPostInterviewsClicked(
  payload: IInterviewRequestPostInterviewsClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:post_interviews_clicked', {
    posting_id: payload.postingId,
    interview_count: payload.interviewCount,
  });
}